import { SITE_ID } from '../constants'
import { Script } from './index'

const projectIdBySiteId = {
  BMAR: 'hxstni6wv4',
  BMCL: 'hxswpuv2o3',
  BMEC: 'hxsx6qfh0o',
  BMMX: 'i1c66yhbms',
  BMPA: 'hxsxke5gq1',
  BMPE: 'hxsw7kob69',
  ZJAR: 'hxsy1q9woz',
}

const clarityCode = (projectId) => `
  (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "${projectId}");
`

const currentSiteId = projectIdBySiteId?.[SITE_ID]

const clarity = (): Script[] =>
  currentSiteId
    ? [
        {
          attributes: [{ name: 'async', value: 'true' }],
          name: 'clarity-script-head',
          parent: 'head',
          location: 'end',
          type: 'script',
          code: clarityCode(currentSiteId),
          lazyLoad: true,
        },
      ]
    : []

export default clarity
